export default __webpack_public_path__ + "static/media/cross.db86f341.mp3";